export type BackAcabadosInfo = {
  idTexturas: number
  identificadorTextura: number
  idGruposDeTexturas: number
  nombre: string
  descripcion: string
  complementos?: string
  nombreFichero?: string
  ruta?: string
  url: string
  urlMiniatura?: string
  factorRepeticionX: number
  factorRepeticionY: number
  opacidad: number
  reflejo: number
  rugosidad: number
  color?: string
  metal: number
  brillo: number
  espejo: boolean
  miniatura?: string
  rugosidadFichero?: string
  factorDeEscala?: number
  descatalogado?: boolean
  idDependencias?: string | number
  grupo?: string | number
  orientacionTextura?: number
  desplazamiento?: number
  zone?: string
}

export default function getStandardMaterial(
  material: BackAcabadosInfo,
  acabado?: string,
  modelo?: string,
) {
  const normalTexture = {
    color: material?.color ?? '#FFFFFF',
    groupID: material?.idGruposDeTexturas,
    searchID: material?.idTexturas,
    id: material?.identificadorTextura,
    description: material?.descripcion,
    url: material?.url,
    repeatX: material?.factorRepeticionX,
    repeatY: material?.factorRepeticionY,
    name: material?.nombre,
    mirror: material?.espejo,
    roughness: material?.brillo,
    displacementScale: material?.factorDeEscala,
    img: material?.miniatura,
    bumpMap: material?.rugosidadFichero,
    displacement: material?.desplazamiento ?? 0,
    envMapIntensity: material?.reflejo,
    metalness: material?.metal,
    bumpScale: material?.rugosidad,
    opacity: material?.opacidad,
    textureRotation: material?.orientacionTextura ?? 0,
    acabado,
    modelo,
    complemento: material?.complementos,
  }
  return normalTexture
}
export type _Material = ReturnType<typeof getStandardMaterial>
